<template>
  <v-dialog data-app="true" :value="dialog" width="800" scrollable @input="$emit('update:dialog', $event)">
    <v-card class="card-termo-adesao">
      <v-card-title>
        <p class="titulo mb-0" :style="{ color: getAssets && getAssets.color ? getAssets.colors.primaryButtonBackground : '' }">Termos de adesão</p>
        <v-flex class="close-dialog">
          <v-btn icon @click="$emit('update:dialog', false)"><v-icon>close</v-icon></v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text id="termos-adesao-card">
        <div class="texto">
          <slot></slot>
        </div>

        <v-btn
          v-if="!hideButtons"
          :width="isMobile ? '100%' : ''"
          :class="isMobile ? 'mb-3' : 'mr-5'"
          class="button-height"
          :color="getAssets.colors.form.buttonBackground"
          :style="{ color: getAssets.colors.form.buttonFont }"
          @click="$emit('agree')"
          >Li e concordo</v-btn
        >
        <v-btn v-if="!hideButtons" :width="isMobile ? '100%' : ''" class="button-height" text color="#B3280D" @click="$emit('update:dialog', false)"
          >cancelar</v-btn
        >
      </v-card-text>

      <div v-if="showArrow" class="arrow-container" @touchstart="arrowTouchStart">
        <span><v-icon class="icon" color="#000" size="65px">south</v-icon></span>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { debounce } from 'lodash'
export default {
  props: {
    dialog: Boolean,
    hideButtons: {
      type: Boolean,
      default: false
    },
    dontShowArrow: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showArrow: true,
    handleDebouncedScroll: null
  }),
  computed: {
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    }
  },
  mounted() {
    if (this.dontShowArrow) {
      this.showArrow = false
    } else {
      this.handleDebouncedScroll = debounce(this.handleScroll, 100)
      const container = document.querySelector('#termos-adesao-card')
      if (!container) return
      container.addEventListener('scroll', this.handleDebouncedScroll)
    }
  },
  beforeDestroy() {
    if (this.handleDebouncedScroll) window.removeEventListener('scroll', this.handleDebouncedScroll)
  },
  methods: {
    handleScroll() {
      this.showArrow = false
    },
    arrowTouchStart() {
      this.showArrow = false
    }
  }
}
</script>

<style lang="scss">
$tablet-size: 960px;

.titulo {
  font-family: 'Roboto', medium;
  font-weight: 500;
  font-size: 20px;
}
.texto {
  span {
    white-space: break-spaces;
    p,
    .v-card__text p {
      font-family: 'Roboto', sans-serif;
      font-size: 14px !important;
      text-align: left !important;
    }
  }
}
.fechar {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px !important;
  line-height: 16px !important;
  text-align: center;
  letter-spacing: 0.75px;
  text-transform: uppercase;
}

.close-dialog {
  text-align: right;
}

.card-termo-adesao {
  position: relative;

  & .arrow-container {
    background: rgb(255, 255, 255);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 1) 100%);
    width: 100%;
    height: 210px;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;

    & span {
      animation: seta 0.5s ease-in 0s infinite alternate;
      font-size: 80px;
      position: absolute;
    }
  }
}

@keyframes seta {
  from {
    top: 10px;
  }
  to {
    top: 50px;
  }
}
</style>
